var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button",
    {
      directives: [
        {
          name: "stock",
          rawName: "v-stock",
          value: {
            detailId: _vm.rowData["detailId"],
            no: _vm.rowData["spu"],
            url: _vm.fieldData["jumpUrl"],
          },
          expression:
            "{ detailId: rowData['detailId'], no: rowData['spu'], url: fieldData['jumpUrl'] }",
        },
      ],
      staticStyle: { "text-decoration": "underline" },
      attrs: { size: "mini", type: "text" },
    },
    [_vm._v("备货数：" + _vm._s(_vm.rowData[_vm.fieldData.fieldCode]))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }